import { Command } from "./command";

export class SaveInvoiceDataCommand extends Command {
  constructor(
    autosaveQueueRef,
    isProcessingQueueRef,
    requestData,
    originalData,
    updateDataCacheFunc,
    updateDataMutation
  ) {
    super();
    this.autosaveQueueRef = autosaveQueueRef;
    this.isProcessingQueueRef = isProcessingQueueRef;
    this.requestData = requestData;
    this.originalData = originalData;
    this.updateDataMutation = updateDataMutation;
    this.updateDataCacheFunc = updateDataCacheFunc;
  }

  async execute() {
    this.autosaveQueueRef.current.push(this.requestData);
    this.updateDataCacheFunc(this.requestData.invoiceId, this.requestData.data);

    if (this.isProcessingQueueRef.current) return true; // Already processing queue. Do nothing
    this.isProcessingQueueRef.current = true;
    try {
      while (this.autosaveQueueRef.current.length) {
        const currentItem = this.autosaveQueueRef.current.shift();
        // eslint-disable-next-line no-continue
        if (!currentItem) continue;
        // eslint-disable-next-line no-await-in-loop
        await this.updateDataMutation.mutateAsync(currentItem);
      }
    } finally {
      this.isProcessingQueueRef.current = false;
    }
    return true;
  }

  async undo() {
    this.autosaveQueueRef.current.push(this.originalData);
    this.updateDataCacheFunc(this.requestData.invoiceId, this.originalData.data);

    if (this.isProcessingQueueRef.current) return true; // Already processing queue. Do nothing
    this.isProcessingQueueRef.current = true;
    try {
      while (this.autosaveQueueRef.current.length) {
        const currentItem = this.autosaveQueueRef.current.shift();
        // eslint-disable-next-line no-continue
        if (!currentItem) continue;

        // eslint-disable-next-line no-await-in-loop
        await this.updateDataMutation.mutateAsync(currentItem);
      }
    } finally {
      this.isProcessingQueueRef.current = false;
    }
    return true;
  }
}
